module.exports = __webpack_public_path__ + "static/img/logo-icon.ca268200.jpg";